{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password",
    "emailOrUsername": "Email Address or Username",
    "emailOrUsernamePlaceholder": "Enter your email or username",
    "signInSubtitle": "Sign in to your account to continue",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password?",
    "signIn": "Sign In",
    "signingIn": "Signing In...",
    "noAccount": "Don't have an account?",
    "requestAccess": "Request Access",
    "requiredField": "This field is required",
    "emailOrUsernameRequired": "Email or username is required",
    "invalidEmailOrUsername": "Enter a valid email address or username",
    "verifyingCredentials": "Verifying your credentials...",
    "signInSuccess": "Successfully signed in! Welcome back.",
    "loginFailed": "Login failed. Please try again."
  },
  "404": {
    "title": "This page's gone fishing.",
    "text": "If you feel that it's not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian",
    "czech": "Czech"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "users": "Users",
    "projects": "Projects"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "manageUsers": "Manage Users",
    "projects": "Projects",
    "myaccount": "My Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "",
  "aboutVuesticAdmin": "About CAMEA Traffic",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "Traffic": "Traffic",
  "Data": "Data",
  "wimData": {
    "viewOptions": "Data View Options",
    "overspeed": "Overspeed",
    "legal": "Legal",
    "unknown": "Unknown",
    "alertsOn": "Alerts on – sound on violations",
    "alertsOff": "Alerts off – click to enable sound on violations",
    "testAlertSound": "Test alert sound",
    "clearAllFilters": "Clear all filters",
    "realtimeOn": "Real-time updates on – click to turn off",
    "realtimeOff": "Real-time updates off – click to turn on",
    "manualRefresh": "Manual refresh",
    "filtersApplied": "{count} filters applied",
    "results": "results",
    "clearFilters": "Clear Filters",
    "updating": "Updating…",
    "loading": "Loading…",
    "loadMore": "Load more",
    "allDataLoaded": "All data loaded",
    "totalRecords": "{count} total records",
    "vehicleDetails": "Vehicle details",
    "unknownPlate": "Unknown Plate",
    "unknownStation": "Unknown Station",
    "unknownValue": "Unknown",
    "tag": "Tag",
    "filterVehicles": "Filter Vehicles",
    "enterTagDetailsHint": "Enter Tag Details To Filter When Loading",
    "licensePlate": "License Plate",
    "enterPlateNumber": "Enter plate number",
    "tooltips": {
      "listView": "List View",
      "cardsView": "Cards View",
      "customView": "Custom View",
      "cycleOverviewImages": "Cycle overview images",
      "thumbnailsFirst": "Currently loading thumbnails first (faster)",
      "fullImagesDirect": "Currently loading full images directly (slower)",
      "expandAllAxles": "Expand All Axles: Toggle to expand/collapse all axle details",
      "speedToggleList": "Speed: Toggle to show/hide speed details in table",
      "imagesToggleList": "Images: Toggle to show/hide image column in table",
      "backPlateToggleList": "Back Plate: Toggle to show/hide back number plate in LicensePlateView",
      "cardLayout": "Card Layout: {n} cards per row",
      "cardsPerRow": "cards per row",
      "expandedView": "Expanded View: Toggle to show/hide all card details",
      "axleVerticalLayout": "Axle Vertical Layout: Headers on top",
      "axleHorizontalLayout": "Axle Horizontal Layout: Headers on side",
      "overlayToggle": "Overlay: Toggle to show/hide vehicle information overlay on images",
      "speedToggleCards": "Speed: Toggle to show/hide speed details on cards",
      "backPlateToggleCards": "Back Plate: Toggle to show/hide back number plate in LicensePlateView",
      "platePosition": "Plate Position: Toggle to place plate in header instead of image overlay",
      "recordsCount": "records",
      "nCards": "{n} Cards"
    },
    "notifications": {
      "overspeedSingle": "Overspeed vehicle detected!\nLicense: {plates}\nSpeed: {speed} km/h",
      "overspeedMultiple": "{count} overspeed vehicles detected!\nLicenses: {plates}",
      "overloadSingle": "Overloaded vehicle detected!\nLicense: {plates}\nWeight: {weight} kg",
      "overloadMultiple": "{count} overloaded vehicles detected!\nLicenses: {plates}",
      "foundMatchingVehicles": "Found {count} matching vehicles"
    }
  },
  "wimTicket": {
    "sectionVehicle": "VEHICLE",
    "sectionVehicleSub": "Vehicle & detection details",
    "sectionSpeed": "SPEED",
    "sectionSpeedSub": "Spot speed vs legal limit",
    "station": "Station",
    "direction": "Direction",
    "detector": "Detector",
    "registration": "Registration",
    "class": "Class",
    "actual": "ACTUAL",
    "limit": "LIMIT",
    "legal": "Legal",
    "excess": "EXCESS",
    "status": "STATUS",
    "statusOver": "OVER",
    "statusOk": "OK",
    "speedCertified": "SPEED · CERTIFIED",
    "pageOf": "Page {i}/{total}",
    "enforcementOnly": "Enforcement Only",
    "yes": "Yes",
    "no": "No",
    "noImage": "No image",
    "ticket": "TICKET",
    "nA": "N/A"
  },
  "wimDashboard": {
    "stationsDashboard": "Stations Dashboard",
    "refresh": "Refresh",
    "stations": "Stations",
    "stationsListView": "Stations List View",
    "speedDashboard": "Speed Dashboard",
    "mapView": "Map View",
    "dataLoadingError": "Data Loading Error",
    "stationsLabel": "Stations",
    "detectorsLabel": "Detectors",
    "retry": "Retry",
    "timePeriods": {
      "allTime": "All-Time",
      "yearly": "Yearly",
      "monthly": "Monthly",
      "daily": "Daily",
      "hourly": "Hourly"
    }
  },
  "wimStations": {
    "onlineStations": "Online Stations",
    "online": "online",
    "detectors": "Detectors",
    "active": "active",
    "maintenance": "Maintenance",
    "underMaintenance": "under maintenance",
    "offlineStations": "Offline Stations",
    "offline": "offline",
    "calibratedStations": "Calibrated Stations",
    "needCalibration": "need calibration",
    "totalStations": "Total Stations",
    "loadingStations": "Loading stations...",
    "maintenanceOnly": "(Maintenance Only)",
    "detectorsOnly": "(Detectors Only)",
    "activeOnly": "(Active Only)",
    "inactiveOnly": "(Inactive Only)",
    "calibrationOnly": "(Calibration Only)",
    "activityOnly": "(Activity Only)",
    "maintenanceBanner": "MAINTENANCE",
    "underMaintenanceBanner": "Under Maintenance",
    "offlineBanner": "OFFLINE",
    "stations": "station",
    "stationsPlural": "stations",
    "totalDirections": "total directions",
    "groupActiveStations": "Active Stations",
    "groupInactiveStations": "Inactive Stations",
    "groupMaintenanceStations": "Maintenance Stations",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "statusMaintenance": "Maintenance"
  },
  "wimSpeed": {
    "refreshData": "Refresh Data",
    "speedViolationsAllTime": "Speed Violations All-Time",
    "speedViolationsToday": "Speed Violations Today",
    "speedViolationsThisMonth": "Speed Violations This Month",
    "speedViolationsThisYear": "Speed Violations This Year",
    "allTime": "All-Time",
    "today": "Today",
    "live": "Live",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "speedViolationRateAnalysis": "Speed Violation Rate Analysis",
    "selectDataToDisplay": "Select Data to Display:",
    "totalTraffic": "Total Traffic",
    "speedViolations": "Speed Violations",
    "detailedSpeedStatistics": "Detailed Speed Statistics",
    "topStationsBySpeedViolations": "Top Stations by Speed Violations",
    "traffic": "Traffic",
    "violations": "Violations",
    "speedViolationsList": "Speed Violations List",
    "speedViolationsListSubtitle": "Individual speed violation records from CAM Report",
    "registrationNumber": "Registration",
    "stationName": "Station",
    "vehicleClass": "Vehicle Class",
    "speedLimit": "Speed Limit (km/h)",
    "actualSpeed": "Actual Speed (km/h)",
    "speedExcess": "Excess (km/h)",
    "violationTime": "Time",
    "loadViolations": "Load Violations",
    "noViolationsFound": "No speed violations found",
    "violationsCount": "{count} violations"
  },
  "wimReports": {
    "title": "WIM Traffic Reports",
    "subtitle": "Comprehensive analytics and insights for Weigh-In-Motion operations",
    "refresh": "Refresh",
    "configTitle": "Report Configuration",
    "configSubtitle": "Select report type and parameters to generate comprehensive analytics",
    "reportType": "Report Type",
    "reportTypePlaceholder": "Select report type",
    "dateRange": "Date Range",
    "station": "Station",
    "allStations": "All stations",
    "vehicleClass": "Vehicle Class",
    "allClasses": "All classes",
    "generateReport": "Generate Report",
    "exportOptions": "Export Options",
    "summaryStatistics": "Summary Statistics",
    "detailedData": "Detailed Data",
    "generatingReport": "Generating report…",
    "noDataTitle": "No Data Available",
    "noDataText": "No data found for the selected criteria. Please adjust your filters and try again.",
    "stats": {
      "totalRecords": "Total Records",
      "totalTraffic": "Total Traffic",
      "speedViolations": "Speed Violations",
      "weightViolations": "Weight Violations",
      "axleViolations": "Axle Violations",
      "dimensionViolations": "Dimension Violations"
    },
    "reportTypes": {
      "trafficFlow": "Traffic Flow Report",
      "totalHourly": "Total Hourly Report",
      "totalDaily": "Total Daily Report",
      "totalMonthly": "Total Monthly Report",
      "totalYearly": "Total Yearly Report",
      "stationHourly": "Station Hourly Report",
      "stationDaily": "Station Daily Report",
      "stationMonthly": "Station Monthly Report",
      "stationYearly": "Station Yearly Report",
      "vehicleClassStationHourly": "Vehicle Class + Station Hourly",
      "vehicleClassStationDaily": "Vehicle Class + Station Daily",
      "vehicleClassStationMonthly": "Vehicle Class + Station Monthly",
      "vehicleClassStationYearly": "Vehicle Class + Station Yearly",
      "dailyHourly": "Daily Hourly Aggregation"
    },
    "columns": {
      "date": "Date",
      "station": "Station",
      "vehicleClass": "Vehicle Class",
      "heightViolations": "Height Violations",
      "widthViolations": "Width Violations",
      "lengthViolations": "Length Violations",
      "trafficAlerts": "Traffic Alerts",
      "hour": "Hour",
      "day": "Day",
      "month": "Month",
      "year": "Year"
    },
    "charts": {
      "dataVisualizations": "Data Visualizations",
      "chartsSubtitle": "Total traffic and speed violations",
      "trafficOverview": "Traffic Overview",
      "speedViolationsOverTime": "Speed Violations Over Time",
      "speedVsTraffic": "Speed vs Traffic"
    },
    "export": {
      "pdf": "PDF",
      "excel": "Excel",
      "csv": "CSV",
      "json": "JSON"
    }
  },
  "Vehicle Inspection": "Vehicle Inspection",
  "Parking": "Parking",
  "Tags": "Tags",
  "Traffic Census": "Traffic Census",
  "Calibration": "Calibration",
  "Tolling": "Tolling",
  "Watchdesk": "Watchdesk",
  "WIM": "WIM",
  "National Weighing": "National Weighing",
  "Factory Weighing": "Factory Weighing",
  "Combined Reports": "Combined Reports",
  "Prosecution": "Prosecution",
  "Reports": "Reports",
  "reportCategories": {
    "dailyHourly": "Daily Hourly",
    "dailyHourlyDesc": "Daily and hourly analysis",
    "timeSeries": "Time Series",
    "dailyMonthly": "Daily Monthly",
    "dailyMonthlyDesc": "Daily to monthly comparison",
    "timeline": "Timeline",
    "monthly": "Monthly",
    "monthlyDesc": "Monthly trend analysis",
    "yearly": "Yearly",
    "yearlyDesc": "Annual performance",
    "annual": "Annual"
  },
  "reportModal": {
    "configuration": "Configuration",
    "configureParams": "Configure parameters for {category} report:",
    "monthRangeSelection": "Month Range Selection",
    "selectMonthRange": "Select month range for comparison",
    "startMonth": "Start Month",
    "endMonth": "End Month",
    "startYear": "Start Year",
    "endYear": "End Year",
    "placeholderStartMonth": "Start month",
    "placeholderEndMonth": "End month",
    "placeholderStartYear": "Start year",
    "placeholderEndYear": "End year",
    "last3Months": "Last 3 Months",
    "last6Months": "Last 6 Months",
    "thisYear": "This Year",
    "lastYear": "Last Year",
    "dateRange": "Date Range",
    "selectDateRangeDaily": "Select specific date range for daily analysis",
    "startDate": "Start Date",
    "endDate": "End Date",
    "placeholderStartDate": "Select start date",
    "placeholderEndDate": "Select end date",
    "yearRangeSelection": "Year Range Selection",
    "selectYearRange": "Select year range for comparison",
    "last3Years": "Last 3 Years",
    "last5Years": "Last 5 Years",
    "last10Years": "Last 10 Years",
    "thisDecade": "This Decade",
    "dateTimeRange": "Date & Time Range",
    "startTime": "Start Time",
    "endTime": "End Time",
    "placeholderStartTime": "00:00",
    "placeholderEndTime": "23:59",
    "configurationSection": "Configuration",
    "enableAINarrations": "Enable AI-Generated Report Narrations",
    "aiNarrationsHint": "Generate AI-powered insights and summaries for each report section",
    "aiModelHint": "Uses Hugging Face T5 model to create professional 50-word narrations for each section",
    "testAIConnection": "Test AI Connection",
    "station": "Station",
    "loadingStations": "Loading stations...",
    "selectStation": "Select station",
    "reportType": "Report Type",
    "exportFormat": "Export Format",
    "selectFormat": "Select format",
    "selectType": "Select type",
    "previewConfiguration": "Preview Configuration",
    "timeRange": "Time Range",
    "aiGeneration": "AI Generation",
    "notSet": "Not set",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "noteFixedReportType": "Report type is fixed to \"{type}\" and cannot be changed",
    "aiNoteInsights": "Will generate intelligent insights for each report section",
    "cancel": "Cancel",
    "generateReport": "Generate Report",
    "loadingReport": "Loading report data...",
    "loadingReportHint": "Please wait while we fetch and process your data",
    "noDataFound": "No Data Found",
    "searchAgain": "Search Again",
    "close": "Close",
    "connectionError": "Connection Error",
    "tryAgain": "Try Again",
    "exportSuccessful": "Export Successful!",
    "reportTitle": "Report"
  },
  "Dashboard": "Dashboard",
  "WIM Data": "WIM Data",
  "WIM Speed": "WIM Speed",
  "WIM Dashboard": "WIM Dashboard",
  "National Weighing": "National Weighing",
  "Multideck": "Multideck",
  "LSWIM": "LSWIM",
  "Mobile Weighing": "Mobile Weighing",
  "Yard Management": "Yard Management",
  "Weigh": "Weigh",
  "Records": "Records",
  "Kiosk Mode": "Kiosk Mode",
  "Inspected Records": "Inspected Records",
  "Parking Records": "Parking Records",
  "Tag Records": "Tag Records",
  "Tag Management": "Tag Management",
  "Census Records": "Census Records",
  "Calibration Dashboard": "Calibration Dashboard",
  "Toll Records": "Toll Records",
  "Prosecution Records": "Prosecution Records",
  "navigationRoutes": {
    "wim": "WIM"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "search": "Search",
    "theme": "Theme",
    "filterByStatus": "Filter by Status",
    "itemsPerPage": "Items per Page",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "actions": "Actions",
    "status": "Status",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday"
  },
  "validation": {
    "required": "{field} is required",
    "positiveNumber": "{field} must be a positive number"
  },
  "shifts": {
    "title": "Shifts",
    "description": "Manage work shifts and schedules",
    "addShift": "Add Shift",
    "basicInformation": "Basic Information",
    "settings": "Settings",
    "scheduleSettings": "Schedule Settings",
    "name": "Name",
    "namePlaceholder": "Enter shift name",
    "description": "Description",
    "descriptionPlaceholder": "Enter shift description",
    "startTime": "Start Time",
    "endTime": "End Time",
    "durationHours": "Duration (Hours)",
    "durationHoursPlaceholder": "Enter duration in hours",
    "color": "Color",
    "colorPlaceholder": "Enter color code (e.g., #3B82F6)",
    "isActive": "Active",
    "isOvertime": "Overtime",
    "daysOfWeek": "Days of Week",
    "selectDays": "Select days",
    "scheduleName": "Schedule Name",
    "scheduleNamePlaceholder": "Enter schedule name",
    "scheduleDescription": "Schedule Description",
    "scheduleDescriptionPlaceholder": "Enter schedule description",
    "maxUsers": "Max Users",
    "maxUsersPlaceholder": "Maximum users per schedule",
    "scheduleIsActive": "Schedule Active",
    "selectedDays": "Selected Days",
    "schedules": "Schedules",
    "scheduleFor": "Schedule for",
    "overtime": "Overtime",
    "regular": "Regular",
    "duration": "Duration",
    "type": "Type",
    "loadError": "Error loading shifts",
    "shiftCreatedSuccess": "Shift created successfully",
    "shiftCreationError": "Error creating shift",
    "activatedSuccess": "Shift activated successfully",
    "deactivatedSuccess": "Shift deactivated successfully",
    "statusToggleError": "Error toggling shift status",
    "deleteConfirmation": "Are you sure you want to delete this shift?",
    "deletedSuccess": "Shift deleted successfully",
    "deleteError": "Error deleting shift",
    "createdSuccess": "Shift created successfully"
  }
}
